<template>
  <el-row :class="`nav__menu  nav--${type} ${isOpen ? 'nav__menu--open' : ''}`" type="flex" justify="start" align="middle">
    <el-col :span="12" class="nav__link nav__link--small">
      <router-link to="/about/us">
        關於我們
      </router-link>
    </el-col>
    <el-col :span="12">
      <el-row>
        <el-col :span="12" class="nav__sub-link">
          <router-link to="/about/company-introduction">
            合作社介紹
          </router-link>
        </el-col>
        <el-col :span="12" class="nav__sub-link">
          <router-link to="/about/career-opportunity">
            合作社理念
          </router-link>
        </el-col>
        <el-col :span="12" class="nav__sub-link">
          <router-link to="/about/feature">
            未來展望
          </router-link>
        </el-col>
        <el-col :span="12" class="nav__sub-link">
          <router-link to="/about/social-responsibility">
            社會責任
          </router-link>
        </el-col>
        <el-col :span="24" class="nav__sub-link">
          <router-link to="/about/shop-note">
            購物須知
          </router-link>
        </el-col>
      </el-row>
    </el-col>
    <el-col :span="12" class="nav__link">
      <router-link to="/products">
        產品列表
      </router-link>
    </el-col>
    <el-col :span="12" class="nav__link">
      <router-link to="/news">
        最新消息
      </router-link>
    </el-col>
    <el-col :span="12" class="nav__link">
      <router-link to="/contact-us">
        聯絡我們
      </router-link>
    </el-col>
    <el-col v-if="isLogin" :span="12" class="nav__link">
      <router-link to="/cart">
        購物車
      </router-link>
    </el-col>
    <el-col v-if="isLogin" :span="12" class="nav__link nav__link--small">
      <router-link to="/user">
        使用者資訊
      </router-link>
    </el-col>
    <el-col v-if="isLogin" :span="12">
      <el-row>
        <el-col :span="12" class="nav__sub-link">
          <router-link to="/address">
            地址管理
          </router-link>
        </el-col>
        <el-col :span="12" class="nav__sub-link">
          <router-link to="/order">
            訂單管理
          </router-link>
        </el-col>
        <el-col :span="12" class="nav__sub-link">
          <router-link to="/rewardLog">
            獎勵歷程
          </router-link>
        </el-col>
        <el-col :span="12" class="nav__sub-link">
          <router-link to="/edit-user">
            變更密碼
          </router-link>
        </el-col>
        <el-col :span="24" class="nav__sub-link">
          <router-link to="/capitalLog">
            股金歷程
          </router-link>
        </el-col>
      </el-row>
    </el-col>
    <el-col :span="12" class="nav__link">
      <div v-if="isLogin" @click="handleLogout">
        登出
      </div>
      <router-link v-else to="/auth">
        社員登入
      </router-link>
    </el-col>
  </el-row>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import api from '@/api'
export default {
  props: {
    type: {
      default: 'mobile',
      type: String
    },
    isOpen: {
      default: false,
      type: Boolean
    }
  },
  computed: {
    ...mapGetters(['isLogin'])
  },
  methods: {
    ...mapActions(['clearUser']),
    async handleLogout() {
      const { account } = api
      await account.logout()
      this.clearUser()
      this.$router.push('/')
    }
  }
}
</script>
<style lang="scss" scoped>
.nav--mobile {
  width: 100%;
  left: 0;
  height: 0px;
  &.nav__menu--open {
    height: auto;
    padding: 20px 0;
  }
}

.nav--desktop {
  width: 0px;
  right: 0;
  top: 0px;
  right: 100px;
  .nav__link {
    margin-bottom: 40px;
    &--small {
    margin-bottom: 20px;
  }
  }
  .nav__sub-link {
    margin-bottom: 20px;
  }
  &.nav__menu--open {
    width: 360px;
    padding: 100px 0;
  }
}

.nav__menu {
  background-color: $deepBlue;
  position: absolute;
  z-index: 10;
  overflow: hidden;
  transition-duration: 0.5s;
  flex-direction: column;
  color: $white;
}
.nav__link {
  font-weight: 600;
  font-size: 16px;
  margin-bottom: 20px;
  text-align: center;
  cursor: pointer;
  &--small {
    margin-bottom: 10px;
  }
}

.nav__sub-link {
  font-size: 14px;
  margin-bottom: 10px;
  text-align: center;
  cursor: pointer;
}
</style>
